/**
 * Messages Store - State
 * Начальное состояние и фабрика state
 */

import type { MessagesState } from './types';

export const createInitialState = (): MessagesState => ({
  conversations: {},
  conversationOrder: [],
  messagesByChat: {},
  typing: {},
  unread: {},
  presence: {},
  currentContactId: null,
  loading: false,
  loadingMore: false,  // Флаг для пагинации (loadMoreMessages в actions.ts)
  hasMore: true,
  lastMessageId: null,
  pendingAcks: {},
  groupedCache: {},
  messageStatusesCache: {},
  objectUrls: new Set(),
  scrollRequest: 0,
});
